import { pickersDayClasses, pickersYearClasses } from "@mui/x-date-pickers";
const createMuiPickersLayout = () => ({
  styleOverrides: {
    root: {
      display: "block",
      [`.${pickersDayClasses.root}`]: {
        "&:hover": {
          backgroundColor: "#caede7"
        },
        "&.MuiPickersDay-today": {
          borderColor: "#00624F",
          backgroundColor: "transparent"
        },
        "&.Mui-selected, &.Mui-selected:focus": {
          backgroundColor: "#00624F",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#004734"
          }
        }
      },
      [`.${pickersYearClasses.yearButton}`]: {
        "&:hover": {
          backgroundColor: "#caede7"
        },
        "&.Mui-selected": {
          backgroundColor: "#00624F",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#004734"
          }
        }
      }
    }
  }
});
export {
  createMuiPickersLayout as default
};
